// src/pages/users/Users.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import UsersTable from "../../components/users/UsersTable";

const Users = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <UsersTable />
        </WrapperSection>
    );
};

export default Users;